const submissions = new WeakMap();

// The native Shopify contact form (including its CAPTCHA) still submits normally.
// Its target keeps the page open while n8n confirms the separate waitlist write.
document.addEventListener('submit', event => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  const container = form.closest('[data-tmp-stock-waitlist]');
  if (!container || !form.checkValidity()) return;
  try {
    const config = JSON.parse(container.querySelector('[data-tmp-stock-config]').textContent);
    if (config.editor) return;
    const emailInput = form.elements.namedItem('contact[email]');
    const email = emailInput?.value.trim();
    if (!email || !emailInput.validity.valid) return;
    const productInfo = form.closest('product-info');
    const selectedData = productInfo?.querySelector('variant-selects [data-selected-variant]');
    const variant = selectedData ? JSON.parse(selectedData.textContent) : config.variant;
    const productForm = document.getElementById(config.productFormId);
    const variantId = String(productForm?.querySelector('[name="id"]')?.value || variant?.id || '');
    if (!variantId || variantId !== String(variant?.id)) return;
    const identity = `${email.toLowerCase()}|${variantId}`;
    let state = submissions.get(form);
    if (state?.pending || (state?.saved && state.identity === identity)) return;
    if (!state || state.identity !== identity) {
      state = {identity, body: JSON.stringify({
        type: 'back_in_stock', email, product_title: config.productTitle,
        product_url: config.productUrl, product_id: String(config.productId),
        variant_id: variantId, sku: variant.sku || '', available: variant.available,
        shop: config.shop, page_url: location.href, submitted_at: new Date().toISOString()
      })};
      submissions.set(form, state);
    }
    const nativeVariant = form.elements.namedItem('contact[Variant ID]');
    if (nativeVariant) nativeVariant.value = variantId;
    if (!state.frame) {
      state.frame = document.createElement('iframe');
      state.frame.name = `stock-contact-${crypto.randomUUID()}`;
      state.frame.title = 'Stock request contact submission';
      state.frame.hidden = true;
      container.append(state.frame);
      form.target = state.frame.name;
    }
    let status = container.querySelector('[data-tmp-stock-status]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.tmpStockStatus = '';
      status.className = 'form-status lh-15 mt-1 mb-0';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      container.append(status);
    }
    const button = form.querySelector('[type="submit"], button:not([type])');
    const originalLabel = button?.getAttribute('aria-label');
    const originalReadonly = emailInput.readOnly;
    state.pending = true;
    status.hidden = false;
    status.textContent = 'Saving your request…';
    form.setAttribute('aria-busy', 'true');
    emailInput.readOnly = true;
    if (button) { button.disabled = true; button.setAttribute('aria-label', 'Saving request'); }
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    (async () => {
      try {
        const response = await fetch(config.webhook, {
          method: 'POST', mode: 'cors', credentials: 'omit',
          headers: {'Content-Type': 'text/plain'}, body: state.body, signal: controller.signal
        });
        if (response.status !== 200 && response.status !== 201) throw new Error('Not accepted');
        const acknowledgement = await response.json();
        if (acknowledgement?.accepted !== true || typeof acknowledgement.registration_id !== 'string' || !acknowledgement.registration_id.trim()) throw new Error('No saved request confirmation');
        state.saved = true;
        status.textContent = 'Your request has been saved. We’ll email you when this item is back in stock.';
        if (button) {
          button.setAttribute('aria-label', 'Request saved');
          button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m5 12 4 4L19 6"/></svg>';
        }
      } catch {
        status.textContent = 'We couldn’t confirm your request. Your email is still here. Please try again or contact us.';
      } finally {
        clearTimeout(timeout);
        state.pending = false;
        form.removeAttribute('aria-busy');
        if (!state.saved) {
          emailInput.readOnly = originalReadonly;
          if (button) {
            button.disabled = false;
            if (originalLabel === null) button.removeAttribute('aria-label');
            else button.setAttribute('aria-label', originalLabel);
          }
        }
      }
    })();
  } catch {}
}, {capture: true, passive: true});
